import { ReactNode, useState } from "react";

import ExtLink from "components/ExtLink";
import TaggedText from "components/TaggedText";

import { IssueSeverity } from "providers/IssuesProvider";

import { cx } from "utils";
import { useLocalStorage } from "hooks/useLocalStorage";
import CloseButton from "components/CloseButton";


const severityToBackgroundColor = (severity: IssueSeverity): string => {
  switch (severity) {
    case 'blocking':
    case "freezing":
    case 'failure':
    case 'warning':
      return 'bg-orange-500 dark:bg-warning-500';
    case 'info':
      return 'bg-brandLightest-75 dark:bg-primary-50';
  }
}

interface IBannerProps {
  title: string | ReactNode;
  dismissible: boolean;
  severity: IssueSeverity;
  permanentCloseKey?: string;
  url?: string | undefined;
}

export function Banner({title, severity = 'info', url, dismissible, permanentCloseKey}: IBannerProps) {
  const [visible, setVisible] = useState(true);
  const [permanentlyClosed, setPermanentlyClosed] = useLocalStorage(`banner-${permanentCloseKey || ''}`, false);
  const bgColor = severityToBackgroundColor(severity);
  if (!visible || (permanentlyClosed && permanentCloseKey)) {
    return null;
  }
  const handleClose = () => {
    setVisible(false);
    if (permanentCloseKey) {
      setPermanentlyClosed(true);
    }
  };
  return (
    <div
      className={cx(
        "dark flex bg-brandLightest-75 dark:bg-primary-50 text-sm text-center p-2.5",
        bgColor
      )}
    >
      <ExtLink disabled={!url} to={url ? url : "#"} className="w-full">
        {typeof title === "string" && (
          <TaggedText
            message={title}
            className="text-sm text-brandDarkest-650 dark:text-primary-800"
            linkStyle="font-bold hover:text-brandDarkest-800 dark:hover:text-primary-900"
          />
        )}
        {typeof title !== "string" && <>{title}</>}
      </ExtLink>

    { dismissible && (
      <CloseButton onPress={handleClose} />
    )}
    </div>
  );
}
